module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold.546b73f1.ttf";